import React, { useEffect, useState } from "react";
import { Item } from "./DashBoard";
import _ from "lodash";
import { formatNumberWithCommas } from "../../../utils/common";
import moment from "moment";

interface HotspotInfoType {
  data?: Item[];
  satelliteName?: string;
  filterData: any;
}
function HotspotInfo({ data, satelliteName, filterData }: HotspotInfoType) {
  const [hotspot, setHotspot] = useState<Item[]>();
  const [statusPending, setStatusPending] = useState(0);
  const [statusInProgress, setStatusInProgress] = useState(0);
  const [statusComplete, setStatusComplete] = useState(0);
  const [hotspotAll, setHotspotAll] = useState(0);
  const [titleText, setTitleText] = useState("");
  const [foundDateText, setFoundDateText] = useState("");

  const handleCheckHotspot = (hotspot: Item[] | undefined) => {
    if (hotspot) {
      let pending = hotspot.filter(
        (item) => item.satellite === "Suomi NPP" && item.status === "pending"
      );
      let inProgress = hotspot.filter(
        (item) =>
          item.satellite === "Suomi NPP" && item.status === "in-progress"
      );
      let complete = hotspot.filter(
        (item) => item.satellite === "Suomi NPP" && item.status === "completed"
      );

      let allHotspot = _.sumBy(data, "count_id");
      setStatusPending(pending.length > 0 ? _.sumBy(pending, "count_id") : 0);
      setStatusInProgress(
        inProgress.length > 0 ? _.sumBy(inProgress, "count_id") : 0
      );
      setStatusComplete(
        complete.length > 0 ? _.sumBy(complete, "count_id") : 0
      );
      setHotspotAll(allHotspot ?? 0);
    } else {
      setStatusPending(0);
      setStatusInProgress(0);
      setStatusComplete(0);
      setHotspotAll(0);
    }
  };

  const handleFormatTitleText = (filter: any) => {
    if (!filter) {
      let title = "";
      let founded = "";
      if (hotspot && hotspot.length > 0) {
        let maxDate: any = _.maxBy(hotspot, "max_updated_at");
        title = `จุดทั้งหมดในประเทศไทย ดาวเทียม Suomi NPP ระบบ VIIRS (วันที่ ${moment(
          filterData?.startDate ? filterData?.startDate : new Date()
        )
          .add(543, "years")
          .format("DD/MM/YYYY")}) `;
        founded = `${moment(maxDate.max_updated_at)
          .utc()
          .tz("Asia/Bangkok")
          .add(543, "years")
          .format("DD/MM/YYYY")} เวลา  ${moment(maxDate.max_updated_at)
          .utc()
          .tz("Asia/Bangkok")
          .format("HH:mm")} น.`;
      } else {
        title = "ไม่พบข้อมูล";
        founded = "";
      }

      setTitleText(title);
      setFoundDateText(founded);
    } else {
      if (hotspot && hotspot.length > 0) {
        if (filter.countryType.id === 1) {
          let maxDate: any = _.maxBy(hotspot, "max_updated_at");
          let title = "";
          let founded = "";
          let countryType = "จุดทั้งหมดในประเทศไทย";
          let region = "";
          let province = "";
          let fileName = filter.fileName;
          let district =
            filter?.district?.DistrictCode !== "0"
              ? filter?.district?.DistrictName
              : "";
          let subdistric =
            filter?.subdistrict?.DistrictCode !== "0"
              ? filter?.subdistrict?.SubdistrictName
              : "";
          let satellite = "";
          let system = "";
          if (filter?.region?.RegionCode !== "0") {
            region = `${filter?.region?.RegionName}`;
          }
          if (
            filter?.satellite === "Suomi NPP" ||
            filter?.satellite === "NOAA-20"
          ) {
            satellite = `ดาวเทียม ${filter?.satellite}`;
            system = `ระบบ VIIRS`;
          }

          if (filter?.satellite === "VIIRS") {
            system = `ระบบ ${filter?.satellite}`;
            satellite = `ดาวเทียม Suomi NPP และ NOAA-20`;
          }

          if (filter?.satellite === "MODIS") {
            system = `ระบบ ${filter?.satellite}`;
          }
          if (filter?.province && filter?.province?.length > 0) {
            const hasProvinceCodeZero = filter?.province.some(
              (item: any) => item?.ProvinceCode === "0"
            );
            if (!hasProvinceCodeZero) {
              const queryString = filter?.province
                .map((province: any) => `${province?.ProvinceName}`)
                .join(" ");
              province = queryString;
              countryType = "จุดในประเทศไทย";
            }
          }
          if (filter?.provinceGroup.id === 2) {
            countryType = "จุดความร้อนกลุ่มจังหวัด 17 จังหวัดภาคเหนือ";
          }
          title = `${countryType} ${region} ${
            province?.trim() !== "" ? `จังหวัด${province}` : ""
          } ${district?.trim() !== "" ? `อำเภอ${district}` : ""} ${
            subdistric?.trim() !== "" ? `ตำบล${subdistric}` : ""
          } ${satellite} ${system} ${
            fileName.trim() !== "" ? `ไฟล์ข้อมูล ${fileName}` : ""
          } (วันที่ ${moment(
            filterData?.startDate ? filterData?.startDate : new Date()
          )
            .add(543, "years")
            .format("DD/MM/YYYY")} ${
            filterData.endDate !== null
              ? `- ` +
                moment(filterData.endDate)
                  .add(543, "years")
                  .format("DD/MM/YYYY")
              : ""
          })`;
          founded = `${moment(maxDate.max_updated_at)
            .utc()
            .tz("Asia/Bangkok")
            .add(543, "years")
            .format("DD/MM/YYYY")} เวลา ${moment(maxDate.max_updated_at)
            .utc()
            .tz("Asia/Bangkok")
            .format("HH:mm")} น.`;
          setTitleText(title);
          setFoundDateText(founded);
        } else if (filter.countryType.id === 2) {
          let title = "";
          let maxDate: any = _.maxBy(hotspot, "max_updated_at");
          let founded = "";
          let countryType = "จุดทั้งหมดในประเทศอาเซียน";
          let fileName = filter.fileName;
          let satellite = "";
          let system = "";
          if (
            filter.satellite === "Suomi NPP" ||
            filter.satellite === "NOAA-20"
          ) {
            satellite = `ดาวเทียม ${filter.satellite}`;
            system = `ระบบ VIIRS`;
          }

          if (filter.satellite === "VIIRS") {
            system = `ระบบ ${filter.satellite}`;
            satellite = `ดาวเทียม Suomi NPP และ NOAA-20`;
          }

          if (filter.satellite === "MODIS") {
            system = `ระบบ ${filter.satellite}`;
          }

          title = `${countryType}  ${satellite} ${system} ${
            fileName.trim() !== "" ? `ไฟล์ข้อมูล ${fileName}` : ""
          } (วันที่ ${moment(
            filterData?.startDate ? filterData?.startDate : new Date()
          )
            .add(543, "years")
            .format("DD/MM/YYYY")})`;
          founded = `${moment(maxDate.max_updated_at)
            .utc()
            .tz("Asia/Bangkok")
            .add(543, "years")
            .format("DD/MM/YYYY")} เวลา  ${moment(maxDate?.max_updated_at)
            .utc()
            .tz("Asia/Bangkok")
            .format("HH:mm")} น.`;
          setTitleText(title);
          setFoundDateText(founded);
        }
      } else {
        setTitleText("ไม่พบข้อมูล");
        setFoundDateText("");
      }
    }
  };
  useEffect(() => {
    handleCheckHotspot(hotspot);
  }, [hotspot]);

  useEffect(() => {
    setHotspot(data);
  }, [data]);

  useEffect(() => {
    handleFormatTitleText(filterData);
  }, [hotspot, filterData]);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between">
        <div className="flex gap-2">
          <div className="w-6 h-6 rounded-full bg-primary-main p-1">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="2.66211"
                y="2"
                width="9.6"
                height="12"
                rx="2"
                stroke="white"
              />
              <path d="M5.0625 5H9.8625" stroke="white" strokeLinecap="round" />
              <path d="M5.0625 8H9.8625" stroke="white" strokeLinecap="round" />
              <path
                d="M5.0625 11H7.4625"
                stroke="white"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <p className="text-base font-normal text-text-primary self-end w-full  line-clamp-1">
            {` ข้อมูล: ${titleText}`}
          </p>
        </div>
        {hotspot && hotspot.length > 0 && (
          <p className="text-sm font-light text-text-secondary self-end line-clamp-1">
            {`ปรับปรุงข้อมูลล่าสุดเมื่อ ${foundDateText}`}
          </p>
        )}
      </div>
      <div className="flex justify-between gap-2 w-full">
        <div className="flex-1 h-auto p-4 flex flex-col gap-2 items-start rounded-3xl bg-primary-contrast shadow-z8">
          <div className="flex w-full justify-between h-auto">
            <div className="flex flex-col">
              <p className="text-sm text-text-primary font-normal">
                รวมจุดความร้อน
              </p>
              {satelliteName && (
                <p className="text-[10px] text-text-primary font-normal">
                  (ดาวเทียม Suomi NPP)
                </p>
              )}
            </div>
            <div className="w-6 h-6 rounded-full bg-primary-main bg-opacity-20 p-[3px]">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.75 0.9375C3.89918 0.9375 4.04226 0.996763 4.14775 1.10225C4.25324 1.20774 4.3125 1.35082 4.3125 1.5V2.31375L5.493 2.0775C6.83798 1.8087 8.2321 1.93691 9.5055 2.4465L9.65775 2.50725C10.7188 2.93163 11.8866 3.01089 12.9952 2.73375C13.2109 2.67983 13.436 2.67578 13.6534 2.72189C13.8708 2.768 14.0749 2.86307 14.2501 2.99986C14.4253 3.13666 14.567 3.31159 14.6644 3.51136C14.7619 3.71113 14.8125 3.93048 14.8125 4.15275V9.678C14.8125 10.419 14.3077 11.0655 13.5885 11.2455L13.428 11.2852C11.986 11.6458 10.467 11.5426 9.087 10.9905C8.01634 10.5623 6.84424 10.4547 5.7135 10.6807L4.3125 10.9613V16.5C4.3125 16.6492 4.25324 16.7923 4.14775 16.8977C4.04226 17.0032 3.89918 17.0625 3.75 17.0625C3.60082 17.0625 3.45774 17.0032 3.35225 16.8977C3.24676 16.7923 3.1875 16.6492 3.1875 16.5V1.5C3.1875 1.35082 3.24676 1.20774 3.35225 1.10225C3.45774 0.996763 3.60082 0.9375 3.75 0.9375ZM4.3125 9.81375L5.493 9.5775C6.83798 9.30874 8.23209 9.43695 9.5055 9.9465C10.6658 10.4105 11.9427 10.4971 13.155 10.194L13.3162 10.1535C13.4223 10.1269 13.5164 10.0657 13.5836 9.97957C13.6509 9.89343 13.6874 9.78729 13.6875 9.678V4.15275C13.6875 4.10144 13.6759 4.0508 13.6534 4.00468C13.631 3.95855 13.5983 3.91815 13.5579 3.88656C13.5174 3.85496 13.4704 3.83299 13.4202 3.82232C13.37 3.81166 13.318 3.81257 13.2682 3.825C11.9302 4.15963 10.5207 4.06411 9.24 3.552L9.087 3.4905C8.01634 3.06228 6.84424 2.95466 5.7135 3.18075L4.3125 3.46125V9.81375Z"
                  fill="#C44A25"
                />
              </svg>
            </div>
          </div>
          <p className="text-xl text-text-primary font-medium">
            {formatNumberWithCommas(hotspotAll)}
          </p>
          <p className="text-sm text-text-primary font-light">จุด</p>
        </div>
        <div className="flex-1 h-auto p-4 flex flex-col gap-2 items-start rounded-3xl bg-primary-contrast shadow-z8">
          <div className="flex w-full justify-between h-auto">
            <div className="flex flex-col">
              <p className="text-sm text-text-primary font-normal">
                รอดำเนินการ
              </p>
              {satelliteName && (
                <p className="text-[10px] text-text-primary font-normal">
                  (ดาวเทียม Suomi NPP)
                </p>
              )}
            </div>
            <div className="w-6 h-6 rounded-full bg-primary-main bg-opacity-20 p-[3px]">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.3157 2.42171C10.3128 2.34551 10.2299 2.29633 10.1648 2.33612C7.64296 3.87862 7.64962 7.64417 7.67989 8.43209C7.68262 8.50309 7.6151 8.55122 7.55159 8.51936C7.22885 8.35744 6.4387 7.82081 6.37863 6.42834C6.37534 6.35205 6.29298 6.30402 6.22761 6.34351C4.74301 7.24028 3.75 8.87562 3.75 10.6875C3.75 13.4834 6.1005 15.75 9 15.75C11.8995 15.75 14.25 13.4834 14.25 10.6875C14.25 6.64272 10.4425 5.75947 10.3157 2.42171Z"
                  stroke="#C44A25"
                />
              </svg>
            </div>
          </div>
          <p className="text-xl text-text-primary font-medium">
            {formatNumberWithCommas(statusPending)}
          </p>
          <p className="text-sm text-text-primary font-light">จุด</p>
        </div>
        <div className="flex-1 h-auto p-4 flex flex-col gap-2 items-start rounded-3xl bg-primary-contrast shadow-z8">
          <div className="flex w-full justify-between h-auto">
            <div className="flex flex-col">
              <p className="text-sm text-text-primary font-normal">
                กำลังดำเนินการ
              </p>
              {satelliteName && (
                <p className="text-[10px] text-text-primary font-normal">
                  (ดาวเทียม Suomi NPP)
                </p>
              )}
            </div>
            <div className="w-6 h-6 rounded-full bg-primary-main bg-opacity-20  p-[3px]">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 1.5L9 3.75"
                  stroke="#C44A25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 14.25L9 16.5"
                  stroke="#C44A25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16.5 9L14.25 9"
                  stroke="#C44A25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.75 9L1.5 9"
                  stroke="#C44A25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.3039 3.6971L12.7129 5.28809"
                  stroke="#C44A25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5.28826 12.7127L3.69727 14.3037"
                  stroke="#C44A25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.69612 3.6971L5.28711 5.28809"
                  stroke="#C44A25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.7117 12.7127L14.3027 14.3037"
                  stroke="#C44A25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
          <p className="text-xl text-text-primary font-medium">
            {formatNumberWithCommas(statusInProgress)}
          </p>
          <p className="text-sm text-text-primary font-light">จุด</p>
        </div>
        <div className="flex-1 h-auto p-4 flex flex-col gap-2 items-start rounded-3xl bg-primary-contrast shadow-z8">
          <div className="flex w-full justify-between h-auto">
            <div className="flex flex-col">
              <p className="text-sm text-text-primary font-normal">
                ดำเนินการแล้วเสร็จ
              </p>
              {satelliteName && (
                <p className="text-[10px] text-text-primary font-normal">
                  (ดาวเทียม Suomi NPP)
                </p>
              )}
            </div>
            <div className="w-6 h-6 rounded-full bg-primary-main bg-opacity-20 p-[3px]">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 5.25L7.5 12.75L3.75 9"
                  stroke="#C44A25"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
          <p className="text-xl text-text-primary font-medium">
            {formatNumberWithCommas(statusComplete)}
          </p>
          <p className="text-sm text-text-primary font-light">จุด</p>
        </div>
      </div>
    </div>
  );
}

export default HotspotInfo;
